module.exports = __webpack_public_path__ + "static/media/slider.d030f5aa.png";